import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledContainer = styled.div`
  .card-wrapper-brands {

    .container {
      padding: 0 0.5rem;
    }
    .icon-arrow-right-external {
      position: initial;
    }
    .chevronContainer[class*='icon-arrow-']::before {
      color: ${baseVariables.color['base20']};
    }
    .carousal_header--cta {
      button {
        background-color: transparent;
        color: inherit;
      }
    }
    .glide__slides_authoring {
      @media only screen and (min-width: 767px) {
        flex-wrap: nowrap !important;
      }
    }
  }

  @media only screen and (max-width: 767px) {
    .card-wrapper-brands {
      ul.glide__slides li {
        margin-left: auto !important;
      }
    }
    .glide__slide--active a:before {
      right: 1rem !important;
    }

    .card-layered {
      min-width:100%
    }
    
    .card-layered .image {
      min-width:100%
    }
    
    .chevronContainer {
      min-width:100%
    }

    .card-wrapper-brands {
      margin: 0 2%;
      width: 96%;
    }
  }
  .m-badge-overlay-merch {
    background-color: rgb(255, 153, 98);
  }

  .t-overline-overlay {
    font-weight: 500;
    color: ${baseVariables.color['base20']};
  }

  .feature-header {
    line-height: 1;
  }

  .mt-2 {
    font-weight: 700;
    text-transform: none;
    color: ${baseVariables.color['base20']};
  }

  .hideCarousel {
    padding: 20px;
    visibility: hidden;
  }
`;

export const StyledBrandsCardsWrapper = styled.div``;
export const StyledBrandsCardsWrapperPreviewMode = styled.div`
  pointer-events: none;
`;
